import React from "react";
import { Tile, CENTS, PACKAGE_LABEL } from "./primitives";

export default function RevenuePanel({ revenue }) {
  const entries = Object.entries(revenue.by_package || {});
  return (
    <Tile title="Revenue" testid="tile-revenue">
      <div className="text-3xl font-mono-num text-[#2B5339] mb-3" data-testid="rev-total">
        {CENTS(revenue.total_usd)}
      </div>
      <div className="text-xs text-[#5C6B62]">
        {revenue.count} paid transactions
      </div>
      <div className="mt-3 space-y-1.5 border-t border-[#E5E2DC] pt-3">
        {entries.map(([pkg, v]) => (
          <div key={pkg} className="flex items-center justify-between text-xs">
            <span className="text-[#5C6B62]">{PACKAGE_LABEL[pkg] ?? pkg}</span>
            <span className="font-mono-num text-[#1C2B23]">
              {v.count} · {CENTS(v.amount)}
            </span>
          </div>
        ))}
        {entries.length === 0 && (
          <div className="text-xs text-[#5C6B62]">No paid transactions yet.</div>
        )}
      </div>
    </Tile>
  );
}
